/*@flow*/
import React from 'react';
import ResourceFormOpener from 'comps/ResourceBuilder/ResourceForm/Link';
import * as I from 'immutable';
import useCachedQuery from 'lib/useCachedQuery';
import NonEmptyArray from 'lib/NonEmptyArray';
import gql from 'graphql-tag';
import type { DocumentNode } from 'graphql';
import resource from 'lib/resource';

export const GetTenant = (gql(`
  query getTenant($tenantId: ID!) {
    me {
      id
      company {
        id
        tenant(id: $tenantId) {
          id
          theGeom
          address
          name
          resourceType
        }
      }
    }
  }
`): DocumentNode);

type Props = {
  tenantId: ID,
  title: string,
  className: string,
};

const Component = (props: Props) => {
  const { data, errors } = useCachedQuery(GetTenant, {
    variables: { tenantId: props.tenantId },
  });
  const tenant = I.getIn(data, ['me', 'company', 'tenant']);
  const theGeom = I.getIn(tenant, ['theGeom'], '');
  const address = I.getIn(tenant, ['address'], '');
  const name = I.getIn(tenant, ['name']);
  if (NonEmptyArray.is(errors)) { return <span>{errors.map((v) => v.error)}</span>; }
  // if (!theGeom) return null;
  return (
    <ResourceFormOpener
      id={null}
      className={props.className}
      resourceName="Event"
      title={props.title}
      resource={{
        tenantId: props.tenantId,
        contactable_id: props.resourceId,
        contactable_type: props.resourceType,
        theGeom,
        status: 'Scheduled',
        address,
        locationName: name,
      }}
    >
      <i className="fa fa-calendar" /> Create Event
    </ResourceFormOpener>
  );
};

export default (Component: any);
